import utils from 'utils'

class chooseUkeyModal {
    constructor($scope, httpRequest, globalFn, logger, sweetalert, $filter, $uibModalInstance, $stateParams, items1) {
        $scope.title = items1.title
        $scope.ukeyList = $scope.userInfo.tax4UkeyList
        console.log($scope.ukeyList)
        $scope.ukeyId = $scope.ukeyList[0].ukeyId
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.ok = function () {
            if (!$scope.ukeyId) return logger.logError('请选择开票点')
            $uibModalInstance.close($scope.ukeyId)
        }
    }
}

chooseUkeyModal.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', 'sweetalert', '$filter', '$uibModalInstance', '$stateParams', 'items1']
export default chooseUkeyModal



// WEBPACK FOOTER //
// ./src/app/outputManage/invoicePool/outputInvoicePool/chooseUkeyModal.js